(function () {
  function getBanner() {
    return document.querySelector('[data-atc-banner]');
  }

  // Klaviyo's popup and its bottom teaser are hidden while the drawer is open -
  // see the qv-cart-drawer-open rules in theme.css.liquid. The class is a
  // belt-and-braces companion to the :has() selector there: Klaviyo renders
  // late and, in some form types, inside its own stacking context where a
  // purely structural selector can miss it.
  function setDrawerOpenFlag(isOpen) {
    document.body.classList.toggle('qv-cart-drawer-open', isOpen);
  }

  function openBanner(banner) {
    setDrawerOpenFlag(true);
    banner.setAttribute('data-animation', 'closed=>open');
    // Force a reflow so the browser registers the closed state before we
    // flip to open, so the CSS transition still runs. Avoids relying on
    // requestAnimationFrame, which doesn't fire reliably in every context.
    void banner.offsetHeight;
    banner.setAttribute('data-animation-state', 'open');
  }

  function closeBanner(banner) {
    setDrawerOpenFlag(false);
    banner.setAttribute('data-animation', 'open=>closed');
    banner.setAttribute('data-animation-state', 'closed');
    window.setTimeout(function () {
      if (banner && banner.parentNode) {
        banner.parentNode.removeChild(banner);
      }
    }, 350);
  }

  function openViewOnlyDrawer() {
    document.dispatchEvent(new Event('closeFlyouts'));

    var template = document.querySelector('[data-templates] [data-atc-banner]');
    var header = document.querySelector('[data-site-header]');
    if (!template || !header) {
      return;
    }

    var existing = header.querySelector('[data-atc-banner]');
    if (existing && existing.parentNode) {
      existing.parentNode.removeChild(existing);
    }

    var banner = template.cloneNode(true);
    banner.classList.add('atc-banner--view-only');
    header.appendChild(banner);

    bindBannerInteractions(banner);
    refreshDrawerCart(banner);
    openBanner(banner);
  }

  function bindBannerInteractions(banner) {
    var closeButton = banner.querySelector('[data-atc-banner-close]');
    if (closeButton) {
      closeButton.addEventListener('click', function () {
        closeBanner(banner);
      });
    }

    // A native "add to cart" flyout dispatches this after appending its own
    // banner, so any view-only drawer we opened earlier needs to get out of
    // the way immediately (no close animation) rather than sit on top of it.
    document.addEventListener('closeFlyouts', function () {
      if (banner.parentNode) {
        banner.parentNode.removeChild(banner);
      }
    });

    banner.addEventListener('click', function (event) {
      if (event.target === banner) {
        closeBanner(banner);
      }
    });
  }

  function refreshDrawerCart(banner) {
    var itemsContainer = banner.querySelector('[data-atc-banner-items]');
    if (!itemsContainer || !window.Theme || !window.Theme.routes) {
      return;
    }

    var url = window.Theme.routes.cart_url + '?section_id=static-cart&_=' + Date.now();

    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var list = doc.querySelector('.cartitems--list');

        if (list) {
          itemsContainer.innerHTML = '';
          itemsContainer.appendChild(list);
          itemsContainer.hidden = false;
        } else {
          itemsContainer.innerHTML = '';
          itemsContainer.hidden = true;
        }

        var subtotalSource = doc.querySelector('[data-cart-total]');
        var subtotalTarget = banner.querySelector('[data-atc-banner-cart-subtotal]');
        if (subtotalSource && subtotalTarget) {
          subtotalTarget.innerHTML = subtotalSource.innerHTML;
        } else if (subtotalTarget && !list) {
          // An empty cart renders the section's "empty" branch, which has no
          // [data-cart-total] - without this the drawer kept showing the old
          // subtotal after the last item was removed (22 Oct 2026).
          subtotalTarget.innerHTML = '<span class="money">£0.00</span>';
        }

        // The free shipping bar only auto-refreshes on the native add-to-cart
        // flow; our own quantity/remove/upsell actions need to update it too.
        var shippingBarSource = doc.querySelector('[data-free-shipping-bar]');
        var shippingBarTarget = banner.querySelector('[data-free-shipping-bar]');
        if (shippingBarSource && shippingBarTarget) {
          shippingBarTarget.innerHTML = shippingBarSource.innerHTML;
        }
      })
      .catch(function () {
        console.error('Cart drawer: unable to refresh bag contents.');
      });

    fetch(window.Theme.routes.cart_url + '.js', { credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var countTarget = banner.querySelector('[data-atc-banner-cart-button] span');
        if (countTarget) {
          countTarget.textContent = cart.item_count;
        }

        var cartProductIds = cart.items.map(function (item) {
          return item.product_id;
        });
        banner.querySelectorAll('[data-atc-banner-upsell-item]').forEach(function (upsellItem) {
          var productId = parseInt(upsellItem.getAttribute('data-product-id'), 10);
          upsellItem.hidden = cartProductIds.indexOf(productId) !== -1;
        });
      })
      .catch(function () {
        console.error('Cart drawer: unable to refresh item count.');
      });
  }

  function updateLineQuantity(key, quantity, banner) {
    fetch(window.Theme.routes.cart_change_url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
        refreshDrawerCart(banner);
      })
      .catch(function () {
        console.error('Cart drawer: unable to update item quantity.');
      });
  }

  function handleQuantityClick(button, delta) {
    var item = button.closest('[data-cartitem-key]');
    var banner = button.closest('[data-atc-banner]');
    var selector = button.closest('quantity-selector');
    var input = selector ? selector.querySelector('[data-quantity-input]') : null;
    if (!item || !banner || !input) {
      return;
    }
    var current = parseInt(input.value, 10) || 1;
    var next = current + delta;
    if (next < 0) {
      next = 0;
    }
    updateLineQuantity(item.getAttribute('data-cartitem-key'), next, banner);
  }

  // Commit a quantity the customer typed straight into the field. The +/-
  // buttons were the only things wired up, so a typed number changed nothing -
  // the line total and subtotal kept showing the old quantity even after
  // pressing return.
  //
  // The input is rendered with the server's quantity in its value attribute,
  // so defaultValue is a reliable record of what the cart actually holds and
  // can be compared against what was typed. defaultValue is reset to the new
  // figure as soon as the request goes out, so the change event that follows a
  // return keypress sees no difference and does not fire a second request.
  function commitQuantityInput(input) {
    var item = input.closest('[data-cartitem-key]');
    var banner = input.closest('[data-atc-banner]');
    if (!item || !banner) {
      return;
    }

    var current = parseInt(input.defaultValue, 10);
    var next = parseInt(input.value, 10);

    // Empty or non-numeric: put the field back to the cart's own figure rather
    // than sending nonsense to /cart/change.
    if (isNaN(next) || next < 0) {
      input.value = isNaN(current) ? 1 : current;
      return;
    }

    if (next === current) {
      return;
    }

    input.defaultValue = String(next);
    // 0 is allowed and removes the line, matching what the minus button does.
    updateLineQuantity(item.getAttribute('data-cartitem-key'), next, banner);
  }

  function addUpsellItem(variantId, banner) {
    fetch(window.Theme.routes.cart_add_url + '.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        return fetch(window.Theme.routes.cart_url + '.js', { credentials: 'same-origin' });
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
        refreshDrawerCart(banner);
      })
      .catch(function () {
        console.error('Cart drawer: unable to add item.');
      });
  }

  window.addEventListener('cartcount:update', function () {
    var banner = getBanner();
    if (banner) {
      refreshDrawerCart(banner);
    }
  });

  document.addEventListener('click', function (event) {
    var removeLink = event.target.closest('[data-atc-banner-items] [data-cartitem-remove]');
    if (removeLink) {
      event.preventDefault();
      var item = removeLink.closest('[data-cartitem-key]');
      var banner = removeLink.closest('[data-atc-banner]');
      if (item && banner) {
        updateLineQuantity(item.getAttribute('data-cartitem-key'), 0, banner);
      }
      return;
    }

    var minusButton = event.target.closest('[data-atc-banner-items] [data-quantity-minus]');
    if (minusButton) {
      event.preventDefault();
      handleQuantityClick(minusButton, -1);
      return;
    }

    var plusButton = event.target.closest('[data-atc-banner-items] [data-quantity-plus]');
    if (plusButton) {
      event.preventDefault();
      handleQuantityClick(plusButton, 1);
      return;
    }

    var upsellButton = event.target.closest('[data-atc-banner-upsell-add]');
    if (upsellButton) {
      event.preventDefault();
      var banner2 = upsellButton.closest('[data-atc-banner]');
      var variantId = upsellButton.getAttribute('data-variant-id');
      if (banner2 && variantId) {
        addUpsellItem(variantId, banner2);
      }
      return;
    }

    var cartButton = event.target.closest('[data-header-cart-open]');
    if (cartButton) {
      event.preventDefault();
      openViewOnlyDrawer();
    }
  });

  // Fires when the field is blurred, and in most browsers on return too.
  // change bubbles, so it can be delegated like the click handlers above.
  document.addEventListener('change', function (event) {
    if (!event.target.closest) {
      return;
    }
    var quantityInput = event.target.closest('[data-atc-banner-items] [data-quantity-input]');
    if (quantityInput) {
      commitQuantityInput(quantityInput);
    }
  });

  document.addEventListener('keydown', function (event) {
    // Return commits the typed quantity immediately rather than waiting for
    // the field to lose focus. preventDefault stops the keypress reaching any
    // enclosing form, which would otherwise navigate away from the drawer.
    if (event.key === 'Enter' && event.target.closest) {
      var quantityInput = event.target.closest('[data-atc-banner-items] [data-quantity-input]');
      if (quantityInput) {
        event.preventDefault();
        commitQuantityInput(quantityInput);
        return;
      }
    }

    if (event.key === 'Escape') {
      var banner = getBanner();
      if (banner) {
        closeBanner(banner);
      }
    }
  });
})();

/* ---------------------------------------------------------------------------
   Lipscore card ratings: re-scan for containers that arrive after page load.

   Product cards render a Lipscore container (see product-grid-item.liquid).
   Lipscore scans the DOM once when its script boots, which covers cards in the
   server-rendered HTML - a collection grid, for example. It does not cover the
   recently-viewed and recommendation carousels, which the theme fetches and
   injects afterwards, leaving those containers empty and starless.

   This rides along in cart-drawer.js because that file is already loaded on
   every page. It deliberately does NOT live in the card snippet: an inline
   <script> inside markup injected via innerHTML never executes, so a script
   shipped with the card would not run in precisely the case that needs it.

   The observer below watches document.body/subtree, which is dangerous: its
   own callback ends in lipscore.initWidgets(), and initWidgets() rewrites
   widget markup, so the callback re-triggers itself. Left unbounded that is a
   permanent CPU cycle - the main thread never idles, and the page stops
   responding to taps while compositor-driven CSS animations (the header
   ticker) keep running, which is exactly how it presented.

   Three bounds keep it safe, and all three must stay:
     busy    - mutations caused by our own initWidgets() call are ignored
     coalesce- at most one selector scan per interval no matter the churn
     MAX_RUNS- hard ceiling, so any path we did not foresee still terminates
   --------------------------------------------------------------------------- */
(function () {
  if (window.__qvLipscoreCardsBound) return;
  window.__qvLipscoreCardsBound = true;

  var pending;
  var deferred = false;
  var busy = false;
  var checkQueued = false;
  var runs = 0;
  var MAX_RUNS = 40;
  var INTERVAL = 400;
  var FRESH = '.qv-card-rating:not([data-qv-ls-requested])';

  function isTyping() {
    var el = document.activeElement;
    return !!el && (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.isContentEditable);
  }

  function hydrate() {
    if (!window.lipscore || typeof window.lipscore.initWidgets !== 'function') return;

    // initWidgets() rewrites widget markup. Doing that while a field is focused
    // churns the DOM under an open on-screen keyboard, and iOS Safari responds
    // by dismissing the keyboard - which is what made tapping the search box
    // feel broken. Checked before any selector work so typing stays cheap.
    if (isTyping()) {
      if (!deferred) {
        deferred = true;
        document.addEventListener('focusout', function onOut() {
          document.removeEventListener('focusout', onOut);
          deferred = false;
          setTimeout(hydrate, 150);
        });
      }
      return;
    }

    // Only containers we have not already handed to Lipscore. The version
    // before this one tested for `.qv-card-rating:empty`, which never stops
    // being true: a product with no reviews leaves its container empty for
    // ever, so the "nothing left to do" guard could never pass.
    var fresh = document.querySelectorAll(FRESH);
    if (!fresh.length) return;

    if (runs++ >= MAX_RUNS) return;

    // Mark before calling, so an un-reviewed product is asked for exactly once.
    for (var i = 0; i < fresh.length; i++) {
      fresh[i].setAttribute('data-qv-ls-requested', '');
    }

    // Everything initWidgets() touches is our own doing - ignore the mutations
    // it causes, or the observer below simply calls us again for ever.
    busy = true;
    try { window.lipscore.initWidgets(); } catch (e) {}
    setTimeout(function () { busy = false; }, INTERVAL + 100);
  }

  // Called for every mutation batch on the page, so it must stay cheap. One
  // selector scan per INTERVAL at most, whatever the volume: a scan that finds
  // nothing has to walk the whole document, and live search re-renders the
  // results list on every keystroke.
  function schedule() {
    if (busy || checkQueued) return;
    checkQueued = true;
    clearTimeout(pending);
    pending = setTimeout(function () {
      checkQueued = false;
      if (busy) return;
      hydrate();
    }, INTERVAL);
  }

  function start() {
    // Still watch for genuinely new rating containers - the cart drawer and
    // lazily rendered cards add them after load - but the marker above means
    // each one triggers a single hydration rather than an endless loop.
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
    // Backstops for containers present before the observer attached, and for
    // Lipscore's own script still loading on the first pass.
    [1000, 3000, 6000].forEach(function (ms) { setTimeout(hydrate, ms); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
